import {PermissionV2} from "../../helper/permission/enum/PermissionV2";
import {checkModifierFn} from "../../helper/permission/helper";

const isNotNull = value => !(value === undefined || value === null);

export class PermissionSpecs {
    keys = []; // IntegrationKey
    requiredLevel = [];
    inhibitorModifiers = [];

    constructor() {
        this.keys = [];
        this.requiredLevel = [];
        this.inhibitorModifiers = [];
    }

    getRequiredLevel(requiredLevel) {
        if (isNotNull(requiredLevel))
            return requiredLevel;

        return isNotNull(this.requiredLevel) ? this.requiredLevel : PermissionV2.update;
    }

    getInhibitorModifiers(inhibitorModifiers) {
        if (isNotNull(inhibitorModifiers))
            return inhibitorModifiers;

        return this.inhibitorModifiers;
    }

    hasSomeModifier(inhibitorModifiers) {
        return checkModifierFn(this.keys, inhibitorModifiers, 'some');
    }
}
